<!-- src\components\course\FAQList.vue -->
<template>
	<div class="faq-list">
		<div class="faq-list__header">
			<h3 class="faq-list__title">Часто задаваемые вопросы</h3>
			<button
				class="faq-list__add-btn"
				type="button"
				@click="$emit('create-faq')"
			>
				Добавить вопрос
			</button>
		</div>

		<div v-if="loading" class="faq-list__loading">
			<div class="spinner"></div>
			<p>Загрузка вопросов...</p>
		</div>

		<div v-else-if="faqs.length === 0" class="faq-list__empty">
			<p class="faq-list__empty-text">FAQ еще не созданы</p>
			<button
				class="faq-list__empty-btn"
				type="button"
				@click="$emit('create-faq')"
			>
				Создать первый вопрос
			</button>
		</div>

		<draggable
			v-else
			v-model="localFaqs"
			item-key="id"
			handle=".faq-card__drag-handle"
			@end="handleReorder"
			class="faq-list__items"
		>
			<template #item="{ element }">
				<FAQCard
					:faq="element"
					@edit="$emit('edit-faq', element)"
					@delete="$emit('delete-faq', element)"
					@toggle-publish="$emit('toggle-publish', element)"
				/>
			</template>
		</draggable>
	</div>
</template>

<script>
import draggable from 'vuedraggable'
import FAQCard from './FAQCard.vue'

export default {
	name: 'FAQList',
	components: {
		draggable,
		FAQCard,
	},
	props: {
		faqs: {
			type: Array,
			default: () => [],
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			localFaqs: [],
		}
	},
	watch: {
		faqs: {
			handler(newFaqs) {
				this.localFaqs = [...newFaqs]
			},
			immediate: true,
		},
	},
	methods: {
		handleReorder() {
			const faqIds = this.localFaqs.map(f => f.id)
			this.$emit('reorder-faqs', faqIds)
		},
	},
}
</script>

<style scoped>
.faq-list {
	width: 100%;
	padding: 40px;
}

.faq-list__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 24px;
}

.faq-list__title {
  color: #000000;
	font-size: 25px;
	font-weight: 700;
	letter-spacing: 0;
	line-height: normal;
	margin: 0;
}

.faq-list__add-btn {
	display: flex;
	align-items: center;
	gap: 8px;
	background-color: #0096ed;
	color: #ffffff;
	border: none;
	border-radius: 8px;
	padding: 10px 20px;
	font-size: 17px;
	font-weight: 700;
	cursor: pointer;
	transition: all 0.3s ease;
}

.faq-list__add-btn:hover {
	background-color: #0085d4;
	transform: translateY(-2px);
}

.faq-list__add-icon {
	font-size: 20px;
	font-weight: 600;
}

.faq-list__loading {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 60px 20px;
	color: #636363;
	font-family: 'Poppins', Helvetica;
	font-size: 14px;
}

.spinner {
	width: 40px;
	height: 40px;
	border: 4px solid #f3f3f3;
	border-top: 4px solid #0095ec;
	border-radius: 50%;
	animation: spin 1s linear infinite;
	margin-bottom: 16px;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.faq-list__empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 60px 20px;
	text-align: center;
}

.faq-list__empty-text {
	color: #636363;
	font-family: 'Poppins', Helvetica;
	font-size: 16px;
	margin-bottom: 20px;
}

.faq-list__empty-btn {
	background-color: #0096ed;
	color: #ffffff;
	border: none;
	border-radius: 8px;
	padding: 12px 24px;
	font-size: 17px;
	font-weight: 700;
	cursor: pointer;
	transition: all 0.3s ease;
}

.faq-list__empty-btn:hover {
	background-color: #0085d4;
	transform: translateY(-2px);
}

.faq-list__items {
	display: flex;
	flex-direction: column;
	gap: 12px;
}
</style>

